/**
 * TXM-472 — "Classificação do cliente" da Classificação NCM: ajuste específico de
 * CNPJ+NCM que sobrepõe a classificação sugerida pela Tabela NCM (TXM-594, ainda não
 * existe — ver ClassificacaoNcm/index.js). Porta o comportamento de
 * icms-classificacao-cliente-store.js (protótipo): override manual salvo no localStorage,
 * chaveado por CNPJ+NCM, mesmo padrão já usado pela classificação por nota do Ecredac
 * (LancamentosEcredac/ecredacClassificacaoStore.js).
 */
export const STORAGE_KEY = "pt_icms_classificacao_cliente";
export const CLASSIFICACOES = ["Insumo", "Uso", "Consumo"];

function normNcm(ncm) {
  return String(ncm || "").replace(/\D/g, "");
}

function normCnpj(cnpj) {
  return String(cnpj || "").replace(/\D/g, "");
}

function chave(cnpj, ncm) {
  return `${normCnpj(cnpj)}|${normNcm(ncm)}`;
}

function loadOverrides() {
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    if (raw) {
      const parsed = JSON.parse(raw);
      if (parsed && typeof parsed === "object") return parsed;
    }
  } catch (e) {
    console.warn("IcmsClassificacaoClienteStore: falha ao ler localStorage", e);
  }
  return {};
}

function saveOverrides(map) {
  try {
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(map));
  } catch (e) {
    console.warn("IcmsClassificacaoClienteStore: falha ao gravar localStorage", e);
  }
}

/** Classificação definida especificamente para este cliente+NCM, ou null se não houver ajuste. */
export function classificacaoCliente(cnpj, ncm) {
  return loadOverrides()[chave(cnpj, ncm)] || null;
}

/** classificacao vazia/nula remove o ajuste, voltando a usar a sugestão do sistema. */
export function definirClassificacaoCliente(cnpj, ncm, classificacao) {
  const overrides = loadOverrides();
  const k = chave(cnpj, ncm);
  if (classificacao) overrides[k] = classificacao;
  else delete overrides[k];
  saveOverrides(overrides);
}
